
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmEmergencyIec as ObiAlarmEmergencyIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-emergency-iec.js';
 
 
 

 
 export const ObiAlarmEmergencyIec = createComponent({
   react: React,
   tagName: 'obi-alarm-emergency-iec',
   elementClass: ObiAlarmEmergencyIecElement,
   events: {
     
   }
  });
 
 